import React, { useEffect, useState } from "react"
import Select from "react-select"

import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  CardText,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  CardTitle,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { formValidation, mapDataForDropDown } from "helpers/helpers"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAllProductChannels } from "store/channels/actions"
import { getAllProductCategories } from "store/categories/actions"
import { createSupplier } from "store/suppliers/actions"
import { apiError } from "store/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import {sitename} from "../../../constants/constants";
const Create = props => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllProductChannels())
    dispatch(getAllProductCategories())
    dispatch(apiError({}))
  }, [])

  const Categories = useSelector(state => state?.productCategories?.Index ?? [])
  const Channels = useSelector(state => state?.productChannels?.Index ?? [])
  const formErrors = useSelector(state => state?.CommonState)

  const [category, setCategory] = useState("")
  const [channel, setChannel] = useState("")
  const [supplierName, setSupplierName] = useState("")
  const [supplierCommission, setSupplierCommission] = useState("")
  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      name: supplierName,
      type: channel.value,
      product_category_id: category.id,
      commision: supplierCommission,
    }
    dispatch(createSupplier(data, props.history))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Supplier" breadcrumbItem="Create" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              supplier details
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Name
                  </Label>
                  <Col sm={5}>
                    <Input
                      type="text"
                      maxLength="25"
                      name="supplierName"
                      onChange={e => {
                        setSupplierName(e.target.value)
                      }}
                    />
                    {formErrors?.name && supplierName == "" ? (
                      <FieldValidation errorMessage={formErrors?.name} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Product Category
                  </Label>
                  <Col sm={5}>
                    <Select
                      onChange={category => {
                        setCategory(category)
                      }}
                      options={mapDataForDropDown(Categories)}
                      classNamePrefix="select2-selection"
                      maxMenuHeight={150}
                    />

                    {formErrors?.product_category_id && category == "" ? (
                      <FieldValidation
                        errorMessage={formErrors?.product_category_id}
                      />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Commission
                  </Label>
                  <Col sm={5}>
                    <Input
                      type="text"
                      maxLength="25"
                      name="commission"
                      onChange={e => {
                        setSupplierCommission(e.target.value)
                      }}
                    />
                    {formErrors?.commision && supplierCommission == "" ? (
                      <FieldValidation errorMessage={formErrors?.commision} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Type
                  </Label>
                  <Col sm={5}>
                    <Select
                      onChange={channel => {
                        setChannel(channel)
                      }}
                      options={[
                        { value: "Online", label: "Online" },
                        { value: "Retail", label: "Retail" },
                      ]}
                      classNamePrefix="select2-selection"
                      maxMenuHeight={150}
                    />

                    {formErrors?.type && channel == "" ? (
                      <FieldValidation errorMessage={formErrors?.type} />
                    ) : null}
                  </Col>
                </div>
                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/supplier-commissions")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const CreateSupplier = withRouter(Create)
